"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Flame = function Flame(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    height: "40",
    width: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.8,0.222L10.8,0.222c-0.61-0.325-1.367-0.094-1.692,0.515C8.914,1.1,8.911,1.535,9.1,1.9 c1.474,2.886,1.488,6.301,0.038,9.2c-0.067,0.12-0.219,0.163-0.339,0.095c-0.042-0.023-0.076-0.058-0.098-0.1 c-0.264-0.492-0.453-1.02-0.56-1.568c-0.053-0.256-0.234-0.466-0.48-0.556c-0.246-0.09-0.52-0.045-0.724,0.119 c-2.868,2.287-3.983,6.134-2.781,9.6c1.137,3.27,4.291,5.4,7.749,5.234c4.229,0,7.186-2.145,8.116-5.882 C21.4,12.525,18.016,4.046,10.8,0.222z M15.537,18.1c-0.25,1.715-1.779,2.949-3.508,2.829c-1.652,0.001-3.066-1.184-3.355-2.811 c-0.049-0.272,0.132-0.532,0.404-0.581c0.067-0.012,0.137-0.01,0.203,0.006c1.018-0.016,1.959-0.547,2.5-1.41 c0.623-0.659,0.8-1.622,0.453-2.46c-0.135-0.241-0.049-0.546,0.191-0.681c0.128-0.072,0.282-0.084,0.42-0.032 C14.813,13.855,15.922,15.973,15.537,18.1z",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Flame.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Flame.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Flame;